/**
 * Gate de 2º factor (F-12). Decisión pura compartida por los `beforeLoad` de
 * `_authenticated/_layout` y `/login`: tras NEW_PASSWORD el user ya tiene tokens
 * (no hay challenge de Cognito que fuerce el MFA), así que el FRONT es la única
 * barrera. Mientras no haya elegido 2º factor (`mfaSetupRequired`), no lo dejamos
 * entrar a la app y lo mandamos a la pantalla de elección.
 */

/** Ruta de la pantalla de elección de 2º factor (post-token, self-service). */
export const MFA_SETUP_PATH = '/me/security/mfa-setup';

/** Prefijo de las rutas donde el user SÍ puede estar mientras completa la elección. */
export const MFA_SETUP_AREA = '/me/security';

/**
 * Devuelve la ruta a la que hay que redirigir por falta de 2º factor, o `null`
 * si el acceso está permitido. No redirige si el user ya está dentro de
 * `/me/security/*` (ahí completa la elección sin rebotar en loop).
 */
export function resolveMfaSetupRedirect(
    user: { mfaSetupRequired: boolean },
    currentPathname: string,
): string | null {
    if (!user.mfaSetupRequired) return null;
    if (currentPathname.startsWith(MFA_SETUP_AREA)) return null;
    return MFA_SETUP_PATH;
}
